export function doStyleSidebarFilters() {
    $('.filter-sections .filter-section-boolean').insertBefore('.filter-section.filter-section-count');

    $('.filter-section .filter-label.active').closest('.filter-section').addClass('open');
    $(".slider-wrapper").prependTo("#category-filter-hover");
    $(`#category-filter-hover > div h4 span:contains('Barva')`).closest('.filter-section').addClass('color');
    $(`#category-filter-hover > div h4 span:contains('Velikost')`).closest('.filter-section').addClass('sizes');
    $('#category-filter-hover .filter-section, #category-filter-hover .slider-wrapper, .box-categories').addClass('open');

    $("body").on("click", ".filter-sections h4", function(event){
        event.preventDefault();
        $(this).closest(".filter-section").toggleClass("open");
        $(this).closest(".slider-wrapper").toggleClass("open");
    });
    $("body").on("click", ".box-categories h4", function(event){
        event.preventDefault();
        $(this).closest(".box-categories").toggleClass("open");
    });
}
